import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { renderTableTitle } from "@/utils/render.jsx";
import store from "store2";
import exportExcel from "@/utils/export-execel";
import importHistory from "./modal/importHistory.vue";
import { userDelete, userList, quitMember } from "@/service/structure";
import { getToken } from "@/libs/auth";
import NoUser from "@/components/NoContent/No";
import { mapState } from "vuex";
import identityIcon from "@/libs/identityIcon";
import BacthUsers from "@/views/MGT/modal/BacthUsers";
import AllJoin from "@/views/MGT/Organizational/modal/AllJoin";
import More from "@/views/MGT/Organizational/Components/More";
export default {
  name: "org-list",
  components: {
    NoUser,
    BacthUsers,
    AllJoin,
    More,
    importHistory
  },
  props: {
    org: {
      type: Object,
      default() {
        return {};
      }
    },
    inviteLoading: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    const h = this.$createElement;
    let windowEidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let widthPhone = windowEidth < 500 ? true : false;
    return {
      tabelData: [],
      config: {
        map: {
          dataPath: "data.retVal.datas",
          message: "msg",
          totalPath: "data.retVal.totalRows"
        },
        ref: "proTable",
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: "/api/userOrganizationAssociate/member/page",
        search: {
          value: {
            orgId: "",
            search: "",
            status: "0,10,50"
          }
        },
        columns: [{
          type: "selection",
          width: 60,
          align: "center"
        }, {
          title: $t("fqmy2", "姓名"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          notShowSearch: true,
          notShowForm: true,
          render: (itemh, {
            row
          }) => {
            return h("span", {
              "attrs": {
                "title": row.userName
              },
              "style": {
                ...this.colorTableForStatus(row),
                ...this.ellipsisTable()
              }
            }, [row.userName]);
          }
        }, {
          title: $t("gfjm2", "工号"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          notShowSearch: true,
          notShowForm: true,
          notShowTable: widthPhone,
          render: (itemh, {
            row
          }) => {
            return h("span", {
              "attrs": {
                "title": row.userNumber
              },
              "style": {
                ...this.colorTableForStatus(row),
                ...this.ellipsisTable()
              }
            }, [row.userNumber]);
          }
        }, {
          title: $t("haa72", "手机"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          notShowSearch: true,
          notShowForm: true,
          notShowTable: widthPhone,
          render: (itemh, {
            row
          }) => {
            return h("span", {
              "attrs": {
                "title": row.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
              },
              "style": {
                ...this.colorTableForStatus(row),
                ...this.ellipsisTable()
              }
            }, [row.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")]);
          }
        }, {
          title: $t("padf2", "邮箱"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          notShowSearch: true,
          notShowForm: true,
          notShowTable: widthPhone,
          render: (itemh, {
            row
          }) => {
            return h("span", {
              "style": {
                ...this.colorTableForStatus(row),
                ...this.ellipsisTable()
              },
              "attrs": {
                "title": row.userEmail
              }
            }, [row.userEmail]);
          }
        }, {
          title: $t("pgxs2", "部门"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          notShowSearch: true,
          notShowForm: true,
          notShowTable: widthPhone,
          render: (itemh, {
            row
          }) => {
            let names = [];
            let hoverTitle = [];
            row.organizations.map(v => {
              if (v.name) {
                let arr = v.name.split("/");
                names.push(arr[arr.length - 1]);
              }
              hoverTitle.push(v.name);
            });
            return h("span", {
              "attrs": {
                "title": hoverTitle.join(" ; ")
              },
              "style": {
                ...this.colorTableForStatus(row),
                ...this.ellipsisTable()
              }
            }, [names.join(" ; ")]);
          }
        }, {
          title: $t("op822", "身份"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          notShowTable: widthPhone,
          render: (itemh, {
            row
          }) => {
            let name = row.isAdmin === "T" ? $t("io38z3", "管理员") : $t("aan4n54", "企业成员");
            return h("span", {
              "attrs": {
                "title": name
              },
              "style": {
                ...this.colorTableForStatus(row),
                ...this.ellipsisTable()
              }
            }, [name]);
          }
        }, {
          title: $t("k1e32", "状态"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          notShowTable: widthPhone,
          render: (itemh, {
            row
          }) => {
            let obj = {
              0: $t("ep0os3", "待邀请"),
              10: $t("fj1g2", "在职"),
              50: $t("lb5z2", "禁用"),
              99: $t("ler52", "离职")
            };
            return h("span", {
              "attrs": {
                "title": obj[`${row.status}`]
              },
              "style": {
                ...this.colorTableForStatus(row),
                ...this.ellipsisTable()
              }
            }, [obj[`${row.status}`]]);
          }
        }, {
          title: $t("hkxb2", "操作"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          align: "center",
          render: (itemh, {
            row
          }) => {
            return h("span", [Number(row.status) === 0 ? h("span", {
              "attrs": {
                "loading": this.inviteLoading
              },
              "on": {
                "click": e => this.openModal("invitation", row, e)
              },
              "style": {
                color: "#2d8cf0",
                cursor: "pointer",
                marginRight: "5px"
              }
            }, [$t("pchj2", "邀请")]) : "", h("span", {
              "on": {
                "click": e => this.openModal("edit", row, e)
              },
              "style": {
                color: "#2d8cf0",
                cursor: "pointer"
              }
            }, [$t("mekb2", "编辑")])]);
          }
        }],
        table: {
          stripe: false,
          "show-summary": false
        },
        page: {
          "show-elevator": false
        },
        hide: {
          search: true,
          toolBar: true
        }
      },
      addUser: {
        visible: false
      },
      proData: [],
      page: {
        total: 0
      },
      no: null,
      identityIcon,
      poptipTitleDelete: "",
      statusList: [{
        code: "0",
        name: $t("ep0os3", "待邀请")
      }, {
        code: "10",
        name: $t("fj1g2", "在职")
      }, {
        code: "50",
        name: $t("lb5z2", "禁用")
      }, {
        code: "99",
        name: $t("ler52", "离职")
      }],
      allNumber: 0,
      update: {
        // name: "addressBookFile",
        action: "/api/file/addressBookImport",
        headers: {
          Authorization: getToken(),
          // store2 会反序列化缓存值，避免 language 请求头携带 JSON 引号。
          language: store.get("language") || "zh-CN"
        },
        format: ["xls", "xlsx", "xlsm"],
        loading: false
      }
    };
  },
  computed: {
    ...mapState(["user"]),
    showNoUser() {
      return this.proData.length === 0 && this.searchStatusIsAll;
    },
    showAllJoin() {
      return this.allNumber && this.isAdmin ? true : false;
    },
    nameNum() {
      return this.page.total || 0;
    },
    isAdmin() {
      let admin = this.user.userInfo.isAdmin === "T";
      if (!admin) {
        this.$set(this.config.columns[this.config.columns.length - 1], "notShowTable", true);
      }
      return admin;
    },
    searchStatusIsAll() {
      let arr = this.config.search.value.status.split(",");
      return arr.length === 0 || arr.length === 4 ? true : false;
    }
  },
  watch: {
    "org.orgId": function (val) {
      this.config.search.value.orgId = val;
      this.searchUser();
    }
  },
  methods: {
    //下载模版
    async onClickTemplate() {
      // let resFile = await exportExcelTXL();
      exportExcel("get", "/api/file/addressBookDownLoad");
    },
    onSuccessExport(res) {
      if (res.result === 0) {
        this.searchUser();
        this.$refs.importHistory.searchReset();
        this.$Message.success(res.retVal);
      } else {
        this.$Message.error(res.msg);
      }
      this.update.loading = false;
    },
    onFormatError(file) {
      this.$Message.error(`${file.name}${$t('96n1wdb', '文件格式不符合，仅允许')}${this.update.format.join(",")}`);
      this.update.loading = false;
    },
    onErrorExport() {
      this.update.loading = false;
    },
    onBefor() {
      this.update.loading = true;
    },
    //打开导入历史弹框
    showHistory() {
      this.$refs.importHistory.init();
    },
    openModal(key, item, e) {
      if (e) {
        this.stopPropagation(e);
      }
      switch (key) {
        case "addUser":
          this.$emit("addUser");
          break;
        case "edit":
          this.$emit("editUser", item);
          break;
        case "detail":
          this.$emit("detailUser", item);
          break;
        case "batch":
          {
            let checkUsers = this.$refs[this.config.ref].getSelection();
            checkUsers.forEach(v => {
              v.name = v.userName;
            });
            this.$refs["BacthUsers"].open(checkUsers);
            break;
          }
        case "invitation":
          this.invitation(item);
          break;
        case "departure":
          this.onDeparture(item);
          break;
        case "delete":
          this.deleteUser();
          break;
        case "allJoin":
          this.$refs["AllJoin"].open(this.org.orgId, this.allNumber);
          break;
        default:
          break;
      }
    },
    stopPropagation(e) {
      e.stopPropagation();
    },
    searchByValue(val) {
      this.config.search.value.search = val;
      this.searchUser();
    },
    /*
     ** 删除成员
     */
    async deleteUser() {
      let selects = this.$refs[this.config.ref].getSelection();
      if (selects.length === 0) {
        this.$Message.warning($t("2elao15", "请选择成员"));
        return;
      }
      let userIds = selects.map(item => item.userId).join(",");
      let unitId = [];
      selects.forEach(v => {
        let ids = v.organizations.map(v => v.unitId);
        unitId = [...unitId, ...ids];
      });
      const params = {
        userIds,
        orgIds: this.org.orgId,
        unitId: unitId.join(",")
      };
      let res = await userDelete(params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("azeh8z4", "删除成功"));
        this.searchUser();
      }
    },
    /*
     ** 搜索成员
     */
    async searchUser() {
      await this.$refs[this.config.ref].searchAction();
      this.getAllJoinList();
      this.checkProData();
    },
    /*
     ** 邀请
     */
    invitation(item) {
      const params = {
        userId: item.userId,
        orgId: item.orgId
      };
      this.$emit("smsGot", params);
    },
    checkProData() {
      let proData = this.$refs[this.config.ref].getDatas();
      this.proData = proData.table;
      this.page = proData.page;
      this.changeNoContent();
    },
    changeNoContent() {
      let noValue = {
        icon: identityIcon["ORG"],
        style: "width: 127px",
        content: $t("i2ya579", "当前组织无任何成员"),
        button: {
          text: $t("e7yhal4", "添加成员"),
          visible: true
        }
      };
      this.no = {
        ...noValue
      };
      if (this.proData.length === 0 && this.searchStatusIsAll) {
        if (this.config.search.value.search) {
          this.no.button.visible = false;
          this.no.content = $t("si6qba1b", "\u6CA1\u6709\u641C\u7D22\u5230 \"${this.config.search.value.search}\" \u76F8\u5173\u5185\u5BB9", {
            "this.config.search.value.search": this.config.search.value.search
          });
          this.no.style = "width: 400px; text-align: center";
        }
      }
    },
    onPopperShowDelete() {
      let a = $t("n47xpwk", "删除后，成员的企业信息记录将完全被清除。");
      let b = $t("f8eik6n", "若该成员属于多部门，则只将该成员从本部门中移除");
      // 1、当前部门为单位
      if (this.org.type === "UNIT") {
        this.poptipTitleDelete = a;
      } else {
        //2、是多部门
        let proTableData = this.$refs[this.config.ref].getDatas().table;
        let boo = proTableData.find(item => {
          return item.organizations.length > 1;
        });
        if (boo) {
          this.poptipTitleDelete = b;
        }
        // 是单部门
        else {
          this.poptipTitleDelete = a;
        }
      }
    },
    colorTableForStatus(row) {
      return {
        color: row.status === 50 ? "rgba(0,0,0,0.3)" : ""
      };
    },
    ellipsisTable() {
      return {
        display: "inline-block",
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      };
    },
    onSearchStatus() {
      this.searchUser();
    },
    /*
     ** 获取未邀请人数
     */
    async getAllJoinList() {
      const params = {
        orgId: this.org.orgId,
        pageSize: 3,
        firstResult: 0,
        status: "0"
      };
      let res = await userList(params);
      if (res.data && res.data.result === 0) {
        this.allNumber = res.data.retVal.totalRows;
      }
    },
    /*
     ** 离职
     */
    async onDeparture() {
      let selects = this.$refs[this.config.ref].getSelection();
      if (selects.length === 0) {
        this.$Message.warning($t("2elao15", "请选择成员"));
        return;
      }
      let boo = selects.some(v => v.status === 0 || v.status === 99);
      if (boo) {
        this.$Message.warning($t("gk2e9bj", "只有 “在职” 和 “禁用” 才能离职"));
        return;
      }
      let unitId = [];
      selects.forEach(v => {
        let ids = v.organizations.map(v => v.unitId);
        unitId = [...unitId, ...ids];
      });
      const params = {
        userIds: selects.map(v => v.userId).join(","),
        unitId: unitId.join([","])
      };
      let res = await quitMember(params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("d1spvi4", "操作成功"));
        this.searchUser();
      }
    }
  }
};